import { render, staticRenderFns } from "./ReferrerReview.vue?vue&type=template&id=4a34d0af&"
import script from "./ReferrerReview.vue?vue&type=script&lang=js&"
export * from "./ReferrerReview.vue?vue&type=script&lang=js&"
import style0 from "./ReferrerReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReferrerReview.vue"
export default component.exports